export const loaderSection = `
    <header>
        <h1 class="loading_screen__title">
            PORTFOLIO 
            <span class="loading_screen__title--detail">// V3</span>
        </h1>
        <p class="loading_screen__subtitle">LOADING</p>
    </header>
    <div>
        <p>PRODUCED BY // PHI&CODE</p>
    </div>
`

export const mapHeader = `
    <span>SOURCE: CIA</span>
    <span>SOURCE: FBI</span>
    <span>SOURCE: U.S. STATE DEPARTMENT</span>
`

export const overlay404 = `
    <div class="glitch" data-text="404 SYSTEM FAILURE">404 SYSTEM FAILURE</div>
    <div class="glow">404 SYSTEM FAILURE</div>
    <p class="subtitle">REBOOTING SEQUENCE</p>
    <div class="scanlines"></div>
`

export const sectionProfile = `
    <div id="profil_wrapper">
        <div class="profile-card">
            <h2>PROFILE</h2>
            <p><strong>Real Name :</strong> David Moisan</p>
            <p><strong>Code Name :</strong> PHI_AND_CODE</p>
            <p><strong>Skills :</strong> TS / Three.js / WebGL / Rust / Node / PHP</p>
            <p><strong>Last Location :</strong> 🇫🇷 France</p>
            <p><strong>Contact :</strong> <a href="mailto:davprocode@gmail.com">☠︎︎☠︎︎☠︎︎☠︎︎☠︎︎☠︎︎☠︎︎☠︎︎☠︎︎☠︎︎☠︎︎</a></p>
        </div>
        <canvas class="profil_canvas"></canvas>
    </div>
`

export const projectModal = `
    <div class="modal-header">
        <div class="modal-header-title">
            <span class="modal-title-point"></span>
            <h3 class="modal-title"></h3>
        </div>
        <button id="modal-close" class="modal-close">✕</button>
    </div>
    <div class="modal-content">
        <div class="modal-date" style="--i: 1;"></div>
        <p class="modal-description" style="--i: 2;"></p>
    </div>
    <div class="modal-footer">
        <a href="#" target="_blank" class="modal-link" style="display: none;">Open →</a>
    </div>
`

export const transitionLoaderToTerminal = `
<div class="holo_distortion"></div>
<div class="holo_ring"></div>
<div class="holo_sweep"></div>
`
